import { VFC, ChangeEvent, memo } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    inputMainContainer: {
      display: 'flex',
      backgroundColor: '#F5F5F5',
      minHeight: 60,
      alignItems: 'center',
      width: '100%',
      height: '100%'
    },
    inputContainer: {
      marginLeft: 10,
      marginRight: 10,
      paddingRight: 10,
      width: '100%'
    },
    input: {
      minHeight: 40,
      width: '100%',
      height: '100%',
      borderColor: '#c1c1c1',
      borderWidth: 1
    },
    textareaMainContainer: {
      display: 'flex',
      backgroundColor: '#F5F5F5',
      minHeight: 121,
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%'
    },
    textareaContainer: {
      marginLeft: 10,
      marginRight: 10,
      marginTop: 10,
      marginBottom: 6,
      paddingRight: 10,
      width: '100%'
    },
    textarea: {
      minHeight: 60,
      maxHeight: 60,
      width: '100%'
    }
  })
);

type Props = {
  value: string | number;
  onChange:
    | ((event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void)
    | undefined;
  type?: string;
  placeholder?: string;
  min?: string;
  multiLine?: boolean;
};

const PrimaryInput: VFC<Props> = props => {
  const {
    value,
    onChange,
    type = 'text',
    min = '0',
    multiLine = false,
    placeholder = ''
  } = props;
  const classes = useStyles();

  return (
    <div
      className={
        multiLine ? classes.textareaMainContainer : classes.inputMainContainer
      }
    >
      <div
        className={
          multiLine ? classes.textareaContainer : classes.inputContainer
        }
      >
        {multiLine ? (
          <textarea
            value={value}
            rows={5}
            onChange={onChange}
            className={classes.textarea}
            placeholder={placeholder}
          />
        ) : (
          <input
            type={type}
            value={value}
            min={min}
            className={classes.input}
            onChange={onChange}
            placeholder={placeholder}
          />
        )}
      </div>
    </div>
  );
};

export default memo(PrimaryInput);
